// extracted by mini-css-extract-plugin
export default {"wrapper":"Spacer_wrapper__y3fBG"};